import axios from 'axios';

import {
  tenatProvisioningURL
} from "../../constants/defaultValues"

const axiosTenant = axios.create()
axiosTenant.interceptors.request.use((config)=>{
  config.baseURL = tenatProvisioningURL
  config.headers = {
    "Content-Type": "application/json",
    "Accept": "application/json",
    "x-api-key": process.env.REACT_APP_TENANT_KEY
  }
  if (config.customHeader){
    config.headers["X-Execution-Arn"] = config.customHeader;
  }
  if (config.tenantHost){
    config.headers["Tenant-Host"] = config.tenantHost;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
})
axiosTenant.interceptors.response.use((response) => {
  return response;
}, (error) => {
  return Promise.reject(error);
});

export default axiosTenant;